import { notification } from "antd";
import React, { createContext, useEffect, useState } from "react";
import io from "socket.io-client";

const SocketContext = createContext();

export default function SocketProvider({ children }) {
	const [api, contextHolder] = notification.useNotification();
	const [totalNotify, setTotalNotify] = useState(0);
	const [newNotify, setNewNotify] = useState();

	useEffect(() => {
		// Kết nối tới server socket
		const socket = io("https://api.goodapp.vn");

		// Emit "login" khi đã có token + current_user trong localStorage.
		// SocketProvider bọc toàn app và effect này chỉ chạy 1 lần, nên nếu
		// người dùng chưa đăng nhập lúc socket connect (vd đang ở /sign-in),
		// phải retry cho tới khi đăng nhập xong thay vì emit ngay 1 lần rồi bỏ qua.
		const trySocketLogin = () => {
			const token = localStorage.getItem("token");
			let currentUser = null;
			try {
				currentUser = JSON.parse(localStorage.getItem("current_user"));
			} catch (e) {
				currentUser = null;
			}
			if (!token || !currentUser?.email) return false;
			socket.emit("login", { token, email: currentUser.email });
			return true;
		};

		// Xử lý sự kiện khi kết nối thành công
		socket.on("connect", () => {
			console.log("Connected to socket server");
			trySocketLogin();
		});
		socket.on("login", (data) => {
			console.log(data);
		});

		// Xử lý sự kiện khi nhận được dữ liệu từ server
		socket.on("message", (data) => {
			console.log("Received data:", data);
		});

		// Xử lý sự kiện khi có lỗi kết nối
		socket.on("error", (error) => {
			console.error("Socket connection error:", error);
		});

		socket.on("notify:count", (data) => {
			console.log(data);
			setTotalNotify(data);
		});
		socket.on("notify:update", (data) => {
			console.log(data);
		});
		socket.on("notify:new", (data) => {
			console.log(data);
			if (data?.sender === "SYSTEM") {
				openNotification(data);
				setNewNotify(data);
			}
		});

		// Retry emit "login" mỗi giây cho tới khi đăng nhập xong (localStorage
		// có token + current_user), sau đó dừng lại.
		const loginRetry = setInterval(() => {
			if (trySocketLogin()) clearInterval(loginRetry);
		}, 1000);

		// Clean up khi component unmount
		return () => {
			clearInterval(loginRetry);
			socket.disconnect();
		};
	}, []);

	const openNotification = (data) => {
		api.open({
			message: data?.title,
			description: data?.content,
			duration: 0,
		});
	};

	return (
		<SocketContext.Provider value={{ totalNotify, newNotify }}>
			{contextHolder}
			{children}
		</SocketContext.Provider>
	);
}

export { SocketContext };
